export const flowIds = ["standard", "bodybalance"] as const;

export type FlowId = (typeof flowIds)[number];

export type LocalizedText = {
  de: string;
  en?: string;
};

export type LegalPage =
  | { type: "redirect"; url: string }
  | { type: "markdown"; text: LocalizedText };

export type InfoPage = {
  id: string;
  title: LocalizedText;
  text: LocalizedText;
};

export type ThemeColors = {
  primary: string;
  primaryHover: string;
  textPrimary: string;
  textPrimaryContrast: string;
  bgMobileFrom: string;
  bgDesktopFrom: string;
};

export type PraxisConfig = {
  flow: FlowId;
  features: {
    contactForm: boolean;
  };
  texts: {
    cancelAppointment: LocalizedText;
    additionalPaymentLegallyInsured: LocalizedText;
    additionalPaymentPrivateInsured: LocalizedText;
  };
  legal: {
    imprint: LegalPage;
    privacy: LegalPage;
  };
  infoPages: InfoPage[];
  theme: ThemeColors;
};

export type PrivacyResponsible = {
  name: string;
  address: string;
  email: string;
  phone: string;
};

export type PrivacyTemplate = {
  type: "template";
  responsible: PrivacyResponsible;
};

export type PraxisConfigInput = {
  flow?: FlowId;
  features?: Partial<PraxisConfig["features"]>;
  texts?: Partial<PraxisConfig["texts"]>;
  legal: {
    imprint: LegalPage;
    privacy: LegalPage | PrivacyTemplate;
  };
  infoPages?: InfoPage[];
  theme?: ThemeColors;
};

export type PraxisConfigResponse = PraxisConfig & {
  hasFavicon: boolean;
};
